import { CdnUrl } from "../../common/constants";
import { combineAddress } from "../../common/utils";
import { BaseApiClient } from "./base/base-api-client";

export class CdnApiClient extends BaseApiClient {
    constructor(path: string) {
        super(combineAddress(CdnUrl, path));
    }
}